import useAuthStore from '@/stores/useAuthStore/useAuthStore'
import { debugLog as log } from '@/utils/debugLog'
import { debounce } from '@/utils/debounce'
import type { AxiosInstance } from 'axios'

let lastActivityTimestamp: number | null = null
let refreshSessionOnActivityCount = 0

const updateActivityTimestamp = () => {
    lastActivityTimestamp = Date.now()
    log('[sessionRefresh] updateActivityTimestamp', lastActivityTimestamp)
}

const refreshSessionOnActivity = (
    SESSION_REFRESH_INTERVAL: number,
    axiosInstance: AxiosInstance
) => {
    const currentTimestamp = Date.now()
    const sessionId = useAuthStore.getState().sessionId
    const accessToken = useAuthStore.getState().accessToken

    if (
        !!accessToken &&
        !!sessionId &&
        (!lastActivityTimestamp ||
            currentTimestamp - lastActivityTimestamp > SESSION_REFRESH_INTERVAL)
    ) {
        if (++refreshSessionOnActivityCount % 100 === 0) {
            log(
                '[sessionRefresh] updateActivityTimestamp',
                lastActivityTimestamp
            )
        }
        updateActivityTimestamp()
        void axiosInstance
            .get(`/api/v1/sessions/${sessionId}`)
            .then(() => {
                log('[sessionRefresh] Session refreshed on activity')
                updateActivityTimestamp()
            })
            .catch((err: unknown) => {
                log(
                    '[sessionRefresh] Error refreshing session on activity',
                    err
                )
            })
    }
}

let mousemoveListenerAdded = false
export const setupMousemoveListener = (
    SESSION_REFRESH_INTERVAL: number,
    axiosInstance: AxiosInstance
) => {
    const handler = debounce(
        () => {
            refreshSessionOnActivity(SESSION_REFRESH_INTERVAL, axiosInstance)
        },
        1000,
        true
    )
    if (!mousemoveListenerAdded) {
        document.addEventListener('mousemove', handler)
        mousemoveListenerAdded = true
        log('[sessionRefresh] mousemove listener added (singleton)')
    }
}
